import ReviewCard from "./ReviewCard";
import styles from "./reviewsMarquee.module.css";

// Auto-sliding review marquee — same seamless CSS scroll as the "Grow Together"
// logo band (GrowTogether.jsx). The track renders two identical copies of the
// reviews and animates translateX(0 → -50%) on a loop, so the seam is invisible.
// Hovering pauses the scroll; prefers-reduced-motion stops it entirely. Pure CSS
// — no autoplay timer, no drag, no external libraries. Spacing is per-card
// `mr-6` (NOT flex gap) so the -50% loop point lands exactly (see the .module.css
// seam note).

export default function ReviewsCarousel({ reviews }) {
  // Two copies: copy 2 is decorative, hidden from assistive tech.
  const copies = [
    { copy: 1, hidden: false },
    { copy: 2, hidden: true },
  ];

  return (
    <div className={styles.marquee}>
      <div className={styles.track}>
        {copies.map(({ copy, hidden }) =>
          reviews.map((review, i) => (
            <ReviewCard
              key={`${copy}-${review?.name ?? "review"}-${i}`}
              review={review}
              className="mr-6"
              {...(hidden ? { "aria-hidden": true } : {})}
            />
          )),
        )}
      </div>
    </div>
  );
}
